import React from 'react';

import { Title } from '../../atoms';

export const Header = props => {
	const { headerTitle } = props;

	return (
		<div className="header">
			<Title>{headerTitle}</Title>
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/Header.js